// @flow

import * as React from 'react';
import {useContext, useState, useMemo} from 'react';

type Overlays = 'partials' | 'errors';

type XRayOverlayStateType = {|
  errors: boolean,
  partials: boolean,
|};

type XRayOverlayContextType = [
  XRayOverlayStateType,
  (name: Overlays, enabled: boolean) => void,
];

const XRayOverlayContext = React.createContext<XRayOverlayContextType>([
  {errors: false, partials: false},
  (name: Overlays, enabled: boolean) => {},
]);

export const XRayOverlayProvider = (props: {children?: React.Node}) => {
  const [overlays, setState] = useState<XRayOverlayStateType>({
    errors: false,
    partials: false,
  });

  const value = useMemo(() => {
    const setOverlay = (name: string, enabled: boolean) =>
      setState({...overlays, [name]: enabled});
    return [overlays, setOverlay];
  }, [overlays]);

  return (
    <XRayOverlayContext.Provider value={value}>
      {props.children}
    </XRayOverlayContext.Provider>
  );
};

export const useOverlay = () => {
  return useContext(XRayOverlayContext);
};
